import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './screens/home';
import TablePositionTeams from './screens/home/components/positionTeams';
import GeneralPostionTable from './screens/home/components/generalPositionTable';
import Layout from './layouts';
import LivePlayerMatch from './screens/LivePlayerFromMatch';
import VisoriaScreen from './screens/VisoriasScreen';
import SearchPlayerScreen from './screens/SearchPlayerScreen';
import StrikerScreen from './screens/StrikerScreen';
import FieldLineUp from './screens/FieldLineUp';
import ChampionsScreen from './screens/ChampionsScreen';
import PlantillaTeamScreen from './screens/PlantillaScreen';
import PlayerProfileScreen from './screens/PlayerProfileScreen';
import MvpScreen from './screens/MvpScreen';
import GoldenBallVotedScreen from './screens/GoldenBallVotedScreen';
import GraphScreen from './screens/GraphScreen';
import OnceIdealVotedScreen from './screens/OnceIdealVotedScreen';
import DefaultScreen from './screens/DefaultScreen';
import RetoFinalInteractivo from './screens/ChallengeScreen';
import RankingGame from './screens/ChallengeScreen';
import GoldenballScreen from './screens/GoldenBallScreen';
import ListMatchesGame from './screens/home/components/matchGames/components/ListMatchesGame';
import ChampionsThrophyScreen from './screens/ChampionsThrophyScreen';
import ListGamesScreen from './screens/ListGamesScreen';
import GoldenBallThrophyScreen from './screens/GoldenBallThrophyScreen';
import ChallengeIntroduceTeamScreen from './screens/ChallengeIntroduceTeamScreen';
import AssitersScreen from './screens/AssitersScreen';
import BestSevenVotedScreen from './screens/BestSevenVotedScreen';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route path='/' element={<Home />}/>
        <Route path='/tablaGeneral' element={<GeneralPostionTable />} />
        <Route path='/table' element={<TablePositionTeams />} />
        <Route path='/player/match/:id' element={<LivePlayerMatch />} />
        <Route path='/visorias' element={<VisoriaScreen />} />
        <Route path='/searchPlayerTeam' element={<SearchPlayerScreen />} />
        <Route path='/tablaGoleo' element={<StrikerScreen />} />  
        <Route path='/lineup/matches/:id' element={<FieldLineUp />} />
        <Route path='/champions/:id' element={<ChampionsScreen />} />
        <Route path='/plantillaTeam/:id' element={<PlantillaTeamScreen />} />
        <Route path='/player/:id' element={<PlayerProfileScreen />} />
        <Route path='/mvp/match/:id' element={<MvpScreen />} />
        <Route path='/voted/goldenBall/:id' element={<GoldenBallVotedScreen />} />
        <Route path='/voted/OnceIdeal/:id'  element={<OnceIdealVotedScreen />} />
        <Route path='/voted/winnerGoldenBall/:id' element={<GoldenballScreen />} />
        <Route path='/voted/graphScreen/:id' element={<GraphScreen phase={'nominatedPlayers'} />} />
        <Route path='/voted/graphScreenXI/:id' element={<GraphScreen phase={'onceIdeal'} />} />
        <Route path='/voted/graphScreenGoldenball/:id' element={<GraphScreen phase={'goldenBall'} />} />
        <Route path='/voted/goldenBallTrophy/:id' element={<DefaultScreen title={'Balon de oro del barril 2025'} description={'Gracias, se han terminado las votaciones, y ya sabemos quien sera el balon de oro, todo sucedera este 11 de noviembre en el sorteo de la copa mariachi MX'} />}  />
        <Route path='/challenge/winnerTeam/:id' element={<RankingGame />} />
        <Route  path='/listMatches/:id' element={<ListGamesScreen />}/>
        <Route path='/challenge/ChampionThrophy/:id' element={<ChampionsThrophyScreen />} />
        <Route path='/challenge/goldenBallThrophy/:id' element={<GoldenBallThrophyScreen />} />
        <Route path='/challenge/introduceTeam/:id' element={<ChallengeIntroduceTeamScreen />} />
        <Route path='/tablaAsistencia' element={<AssitersScreen />} />
        <Route path='/voted/bestSeven/:id' element={<BestSevenVotedScreen />} />
        <Route path='/voted/graphScreenSevenPhaseOne/:id' element={<GraphScreen phase={'nominatedPlayersSeven'} />} />
      </Route>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
